export default __webpack_public_path__ + "static/media/download.776ca920.png";